import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.383 1.783A1 1 0 008.293 2l-3 3H2v6h3.293l3 3A.998.998 0 0010 13.293V2.707a.998.998 0 00-.617-.924zm5.857 4.803l-.708-.708-1.414 1.415-1.414-1.415-.707.708L12.411 8l-1.414 1.414.707.707 1.414-1.414 1.414 1.414.707-.707L13.825 8l1.414-1.414z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.074 2.675A1.5 1.5 0 0012.439 3l-4.5 4.5H3v9h4.939l4.5 4.5a1.497 1.497 0 001.635.325c.562-.233.926-.777.926-1.385V4.06c0-.608-.364-1.152-.926-1.385zm8.784 7.204l-1.06-1.061-2.122 2.122-2.12-2.122-1.06 1.06L18.615 12l-2.12 2.12 1.06 1.062 2.12-2.121 2.121 2.12 1.061-1.06L20.738 12l2.12-2.121z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.148 5.35a2.998 2.998 0 00-3.27.65l-9 9H6v18h9.878l9 9a2.983 2.983 0 003.27.65A2.992 2.992 0 0030 39.88V8.122a2.993 2.993 0 00-1.852-2.772zm17.568 14.408l-2.122-2.122-4.242 4.244-4.242-4.244-2.12 2.122L37.232 24l-4.242 4.242 2.12 2.122 4.242-4.242 4.242 4.242 2.122-2.122L41.474 24l4.242-4.242z",
    clipRule: "evenodd"
  }))
};
export var MuteFilled = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});